import { render, staticRenderFns } from "./TicketsAdmin.vue?vue&type=template&id=224caa09&"
import script from "./TicketsAdmin.vue?vue&type=script&lang=js&"
export * from "./TicketsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports